<script lang="ts">
  import type { OrganizationUser } from "@kontextwerk/control-web-client"
  import {
    UserCalendarIntegrationSurface,
    clearUserProviderAccountOAuthCallbackParams,
  } from "@kontextwerk/control-web-frame"

  const {
    user,
    organizationId,
    canManage = false,
    canDisconnectOwn = false,
  } = $props<{
    user: OrganizationUser
    organizationId: string
    canManage?: boolean
    canDisconnectOwn?: boolean
  }>()

  const oauthReturnPath = $derived.by(() => {
    if (typeof window === "undefined") return null

    const cleared = clearUserProviderAccountOAuthCallbackParams(window.location)
    const parsed = new URL(cleared, window.location.origin)

    return `${parsed.pathname}${parsed.search}#calendar-integration`
  })
  const helpTextIds = {
    calendarAccount: "calendarIntegrationConnectAccount",
    mailAccount: "mailDeliveryAccount",
    writeTarget: "calendarIntegrationWriteTarget",
    readSources: "calendarIntegrationReadSources",
  } as const
</script>

<div id="calendar-integration">
  <UserCalendarIntegrationSurface
    {organizationId}
    userId={user.id}
    {canManage}
    canDisableCalendar={canManage || canDisconnectOwn}
    productName="KehrBlatt"
    writeTargetLabel="KehrBlatt-Kalender"
    managedCalendarName="KehrBlatt Termine"
    {helpTextIds}
    {oauthReturnPath}
  />
</div>

<style lang="less">
  #calendar-integration {
    color: var(--text-invers-100);
  }
</style>
